<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'identity'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Settings</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Settings</a></li>
                            <li class="breadcrumb-item active">Identity Documents</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'identity'"></app-module-menu>
                    <div class="row">
                        <div class="modal fade" id="modal-identity-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('document.type') || checkService.canModify('document.type')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label for="title">Identity Document Name</label>
                                                <input type="text" required [ngClass]="(title.invalid && (title.dirty || title.touched)) ? 'form-control is-invalid' : (title.valid)? 'form-control is-valid':'form-control'" formControlName="title" id="title" placeholder="Identity Document Name">
                                                <div *ngIf="title.invalid && (title.dirty || title.touched)" class="invalid-feedback">
                                                    <div *ngIf="title.errors.required">Identity Document name is required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <input type="hidden" formControlName="ref" id="ref">
                                            <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('document.type')" data-toggle="modal" data-target="#modal-identity-form" (click)="onCancel()">
                                                    <i class="fas fa-plus"></i> Add Identity Document
                                                </button>&nbsp;
                                                <a [routerLink]="['/settings/countries']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/settings/countries/active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/settings/countries/inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>&nbsp;
                                                
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/adverts/Deleted']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Identity Document Name</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let identityRow of identityList;">
                                                    <td>{{identityRow.title}}</td>
                                                    <td>
                                                        <span [class]="identityRow.online === true ? 'badge bg-success' : 'badge bg-danger'" [innerHTML]="identityRow.online === true ? 'Online' : 'Offline'"></span><br>
                                                        <span [class]="identityRow.status.active === true ? 'badge bg-success' : identityRow.status.inactive === true ? 'badge bg-warning' : 'badge bg-danger'" [innerHTML]="identityRow.status.active === true ? 'Active' : identityRow.status.inactive === true ? 'In-Active' : 'Deleted'"></span>
                                                    </td>
                                                    <td>{{identityRow.created}}</td>
                                                    <td>{{identityRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('document.type')" data-toggle="modal" data-target="#modal-identity-form" (click)="getEdit(identityRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <a class="btn btn-secondary" title="View Areas" [routerLink]="['/settings/countries/areas', identityRow.ref]">
                                                                <i class="fas fa-list"></i>
                                                            </a>
                                                            <button type="button" class="btn btn-success" title="Show" *ngIf="checkService.canModify('document.type')" [hidden]="identityRow.online === true" data-toggle="modal" data-target="#modal-online" (click)="getDataFromList(identityRow.title, identityRow.ref)">
                                                                <i class="fas fa-eye"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-secondary" title="Hide" *ngIf="checkService.canModify('document.type')" [hidden]="identityRow.online === false" data-toggle="modal" data-target="#modal-offline" (click)="getDataFromList(identityRow.title, identityRow.ref)">
                                                                <i class="fas fa-eye-slash"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Activate" *ngIf="checkService.canModify('document.type')" [hidden]="identityRow.status.active === true" data-toggle="modal" data-target="#modal-activate" (click)="getDataFromList(identityRow.title, identityRow.ref)">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Deactivate" *ngIf="checkService.canModify('document.type')" [hidden]="identityRow.status.inactive === true" data-toggle="modal" data-target="#modal-deactivate" (click)="getDataFromList(identityRow.title, identityRow.ref)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('document.type')" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList(identityRow.title, identityRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="identityList.length == 0">
                                                    <td colspan="6" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Identity Document Name</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="identityList.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="getIDs($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
<div class="modal fade" id="modal-activate">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Activate Identity Document</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will activate '+identityName+'. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeIDStatus('activate', identityRef)" class="btn btn-outline-light">Activate Identity Document</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-deactivate">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Deactivate Identity Document</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will deactivate '+identityName+'. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeIDStatus('deactivate', identityRef)" class="btn btn-outline-light">Deactivate Identity Document</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-online">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Show Identity Document in App</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will show '+identityName+' in App. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeIDVisibility('show', identityRef)" class="btn btn-outline-light">Show Identity Document in App</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-offline">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Hide Identity Document in App</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will Hide '+identityName+' in App. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeIDVisibility('hide', identityRef)" class="btn btn-outline-light">Hide Identity Document in App</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Identity Document</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+identityName+'. This action is not reversable, are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteID(identityRef)">Delete Identity Document</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
